<script setup>
import { VuePaginate } from '@svifty7/vue-paginate';

const props = defineProps({
  pageCount: {
    type: Number,
    default: 1,
  },
  pageRange: {
    type: Number,
    default: 5,
  },
});

const model = defineModel({ type: Number, default: 0 });

const hideNavigation = computed(() => props.pageCount <= props.pageRange);
</script>

<template>
  <div
    class="ui-pagination"
    :class="{ 'ui-pagination--hide-navigation': hideNavigation }"
  >
    <VuePaginate
      v-model="model"
      :page-count="pageCount"
      :page-range="pageRange"
      class="ui-pagination__pagination"
      prev-class="ui-pagination__item ui-pagination__item--navigation ui-pagination__item--navigation-prev"
      next-class="ui-pagination__item ui-pagination__item--navigation ui-pagination__item--navigation-next"
      prev-link-class="ui-pagination__button ui-pagination__button--navigation"
      next-link-class="ui-pagination__button ui-pagination__button--navigation"
      page-class="ui-pagination__item ui-pagination__item--page"
      page-link-class="ui-pagination__button ui-pagination__button--page"
    >
      <template #prevBtnText>
        <CIcon
          name="arrow-left"
          class="ui-pagination__icon ui-pagination__icon--navigation ui-pagination__icon--navigation-prev"
        />
      </template>

      <template #nextBtnText>
        <CIcon
          name="arrow-left"
          class="ui-pagination__icon ui-pagination__icon--navigation ui-pagination__icon--navigation-next"
        />
      </template>
    </VuePaginate>
  </div>
</template>

<style scoped lang="scss">
.ui-pagination {
  $parent: &;

  &__icon {
    &--navigation {
      width: em(17);
      height: em(29);

      @include media-breakpoint-down(sm) {
        width: em(11);
        height: em(19);
      }
    }

    &--navigation-next {
      transform: scaleX(-1);
    }
  }

  &:deep(#{$parent}__pagination) {
    border-top: 1px solid $color-gray-1;
    padding-top: em(53);
    display: flex;
    align-items: center;
    gap: em(47);

    @include media-breakpoint-down(sm) {
      padding-top: em(33);
      gap: em(18);
    }

    #{$parent} {
      &__item {
        &.disabled {
          a {
            cursor: auto;
          }
        }

        &--navigation {
          &.disabled {
            a {
              color: rgba($color-black, 0.15);
            }
          }
        }

        &--navigation-prev {
          @include media-breakpoint-down(sm) {
            margin-right: auto;
          }
        }

        &--navigation-next {
          @include media-breakpoint-down(sm) {
            margin-left: auto;
          }
        }

        &--page {
          &.disabled {
            a {
              color: $color-red-1;
            }
          }

          &.active {
            a {
              cursor: auto;
              @include link-active;
            }
          }
        }
      }

      &__button {
        @include link;

        &--page {
          font-size: em(32);
          line-height: em(35, 32);

          @include media-breakpoint-down(sm) {
            font-size: em(20);
            line-height: em(22, 20);
          }
        }
      }
    }
  }

  &--hide-navigation {
    &:deep(#{$parent}__pagination) {
      #{$parent} {
        &__item {
          &--navigation {
            display: none;
          }
        }
      }
    }
  }
}
</style>
